import { makeStyles } from '@material-ui/core';

export const HEADER_HEIGHT = 75;

export default makeStyles(({ breakpoints }) => ({
  container: {
    height: HEADER_HEIGHT,
  },

  list: {
    display: 'flex',
  },

  listItem: {
    whiteSpace: 'nowrap',
    paddingLeft: '15px',
  },

  listItemPrice: {
    whiteSpace: 'nowrap',
    paddingLeft: '15px',
    '& > button': {
      border: '0',
    },
  },

  listItemCompact: {
    [breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },

  userIcon: {
    marginRight: 0,

    [breakpoints.up('sm')]: {
      marginRight: 20,
    },
  },
}));
